import { render, staticRenderFns } from "./trionicIndex.vue?vue&type=template&id=a3a45876&scoped=true"
import script from "./trionicIndex.vue?vue&type=script&lang=js"
export * from "./trionicIndex.vue?vue&type=script&lang=js"
import style0 from "./trionicIndex.vue?vue&type=style&index=0&id=a3a45876&prod&lang=scss&scoped=true"
import style1 from "./trionicIndex.vue?vue&type=style&index=1&id=a3a45876&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a45876",
  null
  
)

export default component.exports